import { combineReducers } from "redux";

import loaderReducer from "./loader.reducer";
import HomeReducer from "../../../../components/Home/dependencies/reducer";
import AdminMentorReducer from "../../../AdminModule/Dashboard/AdminDashboard/AdminMentorAction/dependencies/reducer";
import AdminMentorViewReducer from "../../../AdminModule/Dashboard/AdminDashboard/ViewApplication/dependencies/reducer";
import GetMentorFormReducer from "../../../../components/StartupForms/dependencies/reducer";
import LoginpageReducer from "../../../../components/StartupForms/LoginModal/dependencies/reducer";
import AdminMentorListReducer from "../../../AdminModule/Dashboard/AdminDashboard/AllMentorList/dependencies/reducer"
import MentorReducer from "../../../AdminModule/Dashboard/MentorDashboard/dependencies/reducer"
import StartUpReducer from "../../../AdminModule/Dashboard/StartupDashboard/dependencies/reducer"
import AboutUsReducer from "../../../AboutUs/dependencies/reducer";
import BecomeMentorReducer from '../../../BecomeMentor/dependencies/reducer';
import CohartReducer from '../../../CohortProgram/dependencies/reducer';
import GetMentorDataReducer from '../../../GetMentor/dependencies/reducer';
import ComingSoonReducer from  './comingSoonReducer'

const appReducer = combineReducers({
    loader: loaderReducer,
    HomeReducer,
    GetMentorFormReducer,
    LoginpageReducer,
    AdminMentorReducer,
    AdminMentorViewReducer,
    AdminMentorListReducer,
    AboutUsReducer,
    BecomeMentorReducer,
    CohartReducer,
    GetMentorDataReducer,
    MentorReducer,
    StartUpReducer,
    comingSoon: ComingSoonReducer
});
export default appReducer;
